import React from 'react';
import 'react-day-picker/dist/style.css';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

// import { License } from '../pages/license/license';
import { useConfig } from '../_components/config';
import { ProtectedRoute } from '../_components/protected-route';
import { AppLayout } from '../layout';
import { Compliance } from '../pages/compliance';
import { LandingPage } from '../pages/forms';
import { Form } from '../pages/forms/create';
import { RetryExpired } from '../pages/forms/create/retry-expired';
import { formSteps } from '../pages/forms/create/steps/use-steps';
import { ValidationForm } from '../pages/forms/update';
import { UpdateSubmissionResult } from '../pages/forms/update/submission';
import { Goodbye } from '../pages/license/decline';
import { NotFound } from '../pages/not-found';
import { Request } from '../pages/request';
import { RequestSent } from '../pages/request/form/request-sent';
import { SessionAvailable } from '../pages/request/form/session-available';
import { Retirement } from '../pages/retirement';
import { SessionExpired } from '../pages/session-expired';
import { Unauthorized } from '../pages/unauthorized';
import { VersionInfo } from '../pages/version-info';
import '../sass/style.scss';

export function Routes() {
  const { env } = useConfig();
  if (!env) {
    throw new Error('No `env` value found in config');
  }

  const isTestEnv = !['pre-prod', 'prod'].includes(env.toLowerCase());

  const retiredRoutes = [
    {
      path: '/',
      element: <AppLayout />,
      children: [
        {
          path: '/',
          element: <Navigate to={'/retirement'} />,
        },
        {
          path: 'retirement',
          element: <Retirement />,
        },
        {
          path: 'version',
          element: <VersionInfo />,
        },
        {
          path: 'unauthorized',
          element: <Unauthorized />,
        },
        {
          path: '*',
          element: <NotFound />,
        },
        // Redirects to retirement to deal with bookmarks
        {
          path: 'compliance',
          element: <Retirement />,
        },
        {
          path: 'request',
          element: <Retirement />,
        },
        {
          path: 'update',
          element: <Retirement />,
        },
        {
          path: 'home',
          element: <Retirement />,
        },
      ],
    },
  ];

  const standardRoutes = [
    {
      path: '/',
      element: <AppLayout />,
      children: [
        {
          path: '/',
          element: <Navigate to={'/compliance'} />,
        },
        {
          path: 'compliance',
          element: <Compliance />,
        },
        {
          path: 'version',
          element: <VersionInfo />,
        },
        {
          path: 'request',
          element: <Request />,
        },
        // {
        //   path: 'license',
        //   element: <License />,
        // },
        {
          path: 'form',
          element: <Form />,
          children: formSteps.map(({ element, path }) => ({ element, path })),
        },
        {
          path: 'unauthorized',
          element: <Unauthorized />,
        },
        {
          path: 'update',
          element: (
            <ProtectedRoute feature="update-precert">
              <ValidationForm />
            </ProtectedRoute>
          ),
        },
        {
          path: 'submitted/:precertificationId',
          element: (
            <ProtectedRoute feature="update-precert">
              <UpdateSubmissionResult />
            </ProtectedRoute>
          ),
        },
        {
          path: 'home',
          element: (
            <ProtectedRoute feature="update-precert">
              <LandingPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'thanks',
          element: <Goodbye />,
        },
        {
          path: 'expired',
          element: <SessionExpired />,
        },
        {
          path: 'closed-session',
          element: <RetryExpired />,
        },
        {
          path: 'request-sent-dev',
          element: (
            <ProtectedRoute feature="test">
              <RequestSent email="" onNext={() => {}} />
            </ProtectedRoute>
          ),
        },
        {
          path: 'session-available-dev',
          element: (
            <ProtectedRoute feature="test">
              <SessionAvailable onNext={() => {}} />
            </ProtectedRoute>
          ),
        },
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
  ];

  const routes = isTestEnv ? standardRoutes : retiredRoutes;
  const router = React.useMemo(() => createBrowserRouter(routes), [isTestEnv]);

  return <RouterProvider router={router} />;
}
